
import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";
import BookViewer from "@/views/UnterrichtKnowledge/BookViewer.vue";
import { BooksAllowedEnum } from "@/enums/BooksAllowedEnum";

const WikiDriveBuzzModule = namespace("wiki-drive-buzz");

@Component({
  components: { BookViewer },
})
export default class BaseKnowledge extends Vue {
  public name = "UnterrichtBaseKnowledge";
  public bookId = BooksAllowedEnum.BASE_KNOWLEDGE;

  @WikiDriveBuzzModule.Action("findBook")
  public findBook: any;

  @WikiDriveBuzzModule.Getter("getBaseBook")
  public bookData: any;

  @WikiDriveBuzzModule.Getter("getBaseBookPage")
  public currentPage: any;

  public async mounted(): Promise<void> {
    await this.findBook(this.bookId);
  }
}
